import { Tag } from '@design-system/components/tag/tag';
import { LibraryList, LibraryListProps } from './libraryList';
import { SearchInput } from '@design-system/components/searchinput';
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons';
import { Typography } from '@design-system/components/typography/typography';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ContentFilters } from '@client/new/common/library/helpers';
import { Toggle } from '@client/components/common/inputs/Toggle';
import { Col, Row } from '@design-system/components/grid/grid';

type LibraryProps = LibraryListProps & {
  searchText: string;
  actionsDisabled: boolean;
  search: (value: string) => void;
  filterVideos: (type: ContentFilters) => void;
  activeVideoFilter: ContentFilters | null;
  backFromCurrentFolder: () => void;
  videoType: ContentFilters | null;
  smallerView: boolean;
  multipleChoice: boolean;
  enableFilteringByExtrasVideo?: boolean;
};

export const Library = (p: LibraryProps) => {
  const { searchText, search } = p;
  return (
    <>
      {!p.currentFolder ? null : (
        <div>
          <div className="flex gap-4 items-center py-2 border-b-2">
            <FontAwesomeIcon
              icon={faArrowLeft}
              onClick={p.backFromCurrentFolder}
              className="cursor-pointer"
            />
            <div className="flex flex-col gap-1">
              <Typography variant="body" size="medium">
                {p.currentFolder.name}
              </Typography>
              <Typography variant="body" size="small" color="N-80">
                {p.currentFolder.count}
              </Typography>
            </div>
          </div>
        </div>
      )}
      <Row className="flex gap-4">
        {p.enableFilteringByExtrasVideo && (
          <Col>
            <Row>
              <Typography variant="body" size="large">
                Extras video
              </Typography>
              <Toggle
                value={p.activeVideoFilter === 'extras-video'}
                onChange={() => p.filterVideos('extras-video')}
                variant="primary"
              />
            </Row>
          </Col>
        )}
        <Col justifyEnd>
          <Row>
            <Tag
              label="⚡️ Clip"
              onClick={() => p.filterVideos('short')}
              selected={p.activeVideoFilter === 'short'}
              disabled={!!p?.videoType}
            />
            <Tag
              label="📹 Video"
              onClick={() => p.filterVideos('long')}
              selected={p.activeVideoFilter === 'long'}
              disabled={!!p?.videoType}
            />
          </Row>
        </Col>
      </Row>
      <SearchInput
        placeholder="Search by name"
        value={searchText}
        onChange={(e) => search(e.target.value)}
        onClear={() => search('')}
        inputWrapperClassName="bg-[#EEEEEE]"
      />
      <div className="max-h-[400px]" style={{ userSelect: 'none' }}>
        <LibraryList {...p} />
      </div>
    </>
  );
};
